import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Cait = makeShortcode("Cait");
const Menu = makeShortcode("Menu");
const NoCait = makeShortcode("NoCait");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Ophilia Single Story" mdxType="SEO" />
    <h3 {...{
      "id": "chapter-1"
    }}>{`Chapter 1`}</h3>
    <p>{`Guide Summon Winds`}<br parentName="p"></br>{`
`}{`Purchase Quartz Rod`}</p>
    <h4 {...{
      "id": "guardian-1924hp"
    }}>{`Guardian 1924HP`}</h4>
    <p>{`Summon, Holy Light x4 when Broken`}</p>
    <Cait mdxType="Cait">
      <p>{`Guide Flurry Guy`}</p>
      <p>{`Head to `}<strong parentName="p">{`Scholar Shrine`}</strong>{`, kill Cait on the way.`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "jobs"
        }}>{`Jobs`}</h5>
        <p><strong parentName="p">{`Scholar`}</strong>{`, Blizzard, Lightning Blast`}</p>
        <h5 {...{
          "id": "equip-skills"
        }}>{`Equip Skills`}</h5>
        <p>{`Evasive Maneuvers`}</p>
      </Menu>
      <p>{`Tag `}<strong parentName="p">{`Noblecourt`}</strong>{`, tag `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}</p>
    </Cait>
    <NoCait mdxType="NoCait">
      <p>{`Head to `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}</p>
      <h3 {...{
        "id": "cyrus-ch1"
      }}>{`Cyrus Ch.1`}</h3>
      <p>{`Scrutinize `}<strong parentName="p">{`Light S`}</strong>{`, `}<strong parentName="p">{`Light M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Quartz Rod`}</strong>{` & equip to Cyrus`}</p>
      <p>{`Optionally pick `}<strong parentName="p">{`Light S`}</strong>{` in Study`}</p>
      <h4 {...{
        "id": "russell-3097hphp"
      }}>{`Russell 3097HP/?HP`}</h4>
      <p>{`Summon for Wind and Break Russell`}<br parentName="p"></br>{`
`}{`Use Fire Ball T1 and T2 for Break Icicle`}<br parentName="p"></br>{`
`}{`Use 1 Small Soulstone + Max Icy Wind for kill Icicle (need 1 winds)`}<br parentName="p"></br>{`
`}{`When Russell are broken use BPx4 Holy Light and BPx4 Fire Ball/Small Stone`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "job"
        }}>{`Job`}</h5>
        <ul>
          <li parentName="ul">{`Cyrus: Lightning Blast`}</li>
        </ul>
      </Menu>
      <p>{`Go to Whistlewood, kill stuff till Cyrus has enough JP for EM`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "job-1"
        }}>{`Job`}</h5>
        <ul>
          <li parentName="ul">{`Cyrus: Blizzard`}</li>
        </ul>
        <h5 {...{
          "id": "equip-skills-1"
        }}>{`Equip Skills`}</h5>
        <ul>
          <li parentName="ul">{`Cyrus: Evasive Maneuvers`}</li>
        </ul>
      </Menu>
    </NoCait>
    <h3 {...{
      "id": "exploration"
    }}>{`Exploration`}</h3>
    <p>{`Head towards `}<strong parentName="p">{`Grandport`}</strong>{`. Tag `}<strong parentName="p">{`Rippletide`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`North Cobbleston Gap`}</strong>{`: Optionally pick `}<strong parentName="p">{`Light S`}</strong>{`. Pick `}<strong parentName="p">{`$1200`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Moonstruck Coast`}</strong>{`: S&Q, get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Goldshore`}</strong>{`. `}<strong parentName="p">{`Grandport Coast`}</strong>{`: Pick `}<strong parentName="p">{`Wind L`}</strong>{`, return to previous screen. Pick `}<strong parentName="p">{`Thunder M`}</strong>{`, re-enter.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$20000`}</strong>{`, S&Q. Pick `}<strong parentName="p">{`Thunder L`}</strong>{`, tag `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <Cait mdxType="Cait">
      <p>{`Go to `}<strong parentName="p">{`Loch of the Lost King`}</strong>{`. Pick `}<strong parentName="p">{`Wind L`}</strong>{` and `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
      <p>{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}</p>
      <h3 {...{
        "id": "cyrus-ch1-1"
      }}>{`Cyrus Ch.1`}</h3>
      <h4 {...{
        "id": "russel"
      }}>{`Russel`}</h4>
      <p>{`Wind L`}</p>
    </Cait>
    <p>{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <h4 {...{
      "id": "mikk--makk"
    }}>{`Mikk & Makk`}</h4>
    <p>{`Wind L`}</p>
    <p>{`Head to `}<strong parentName="p">{`Shrine of the Runeblade`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light M`}</strong>{`, `}<strong parentName="p">{`Light L`}</strong>{`. Pick `}<strong parentName="p">{`$50000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`.`}</p>
    <Cait mdxType="Cait">
      <p>{`Scrutinize `}<strong parentName="p">{`Thunder L`}</strong>{` and pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    </Cait>
    <p>{`Head to `}<strong parentName="p">{`Sunshade`}</strong>{`. Pick `}<strong parentName="p">{`Old Coin`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch1"
    }}>{`Primrose Ch.1`}</h3>
    <Cait mdxType="Cait">
      <p>{`Catacombs battle Thunder M`}</p>
    </Cait>
    <h4 {...{
      "id": "helgenish-4577hp"
    }}>{`Helgenish 4577HP`}</h4>
    <p>{`Light L & Light M`}</p>
    <NoCait mdxType="NoCait">
      <p>{`TP `}<strong parentName="p">{`Grandport`}</strong>{`. Go to `}<strong parentName="p">{`Loch of the Lost King`}</strong>{`. Pick `}<strong parentName="p">{`Wind L`}</strong>{` and `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
    </NoCait>
    <p>{`TP `}<strong parentName="p">{`Grandport`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Allure Inhibit Defences Girl (30%)`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$8000`}</strong>{`. Purchase `}<strong parentName="p">{`HGB, Pom L`}</strong>{`. Purchase `}<strong parentName="p">{`Pom M, Pom L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$25000`}</strong>{`, `}<strong parentName="p">{`Dazzling Artwork`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Sunshade`}</strong>{`, head to `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <h4 {...{
      "id": "saintsbridge-battle"
    }}>{`Saintsbridge Battle`}</h4>
    <p>{`Ice M + Ice/Light S ideally. If Shadow S, need 22 damage to Salamander.`}<br parentName="p"></br>{`
`}{`Prim Flurry (needs 4 hit) or 2M are also options.`}</p>
    <h3 {...{
      "id": "chapter-2"
    }}>{`Chapter 2`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Shadow M`}</strong>{`, `}<strong parentName="p">{`Shadow L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Scrutinize `}<strong parentName="p">{`More Items in Shop (30%)`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`Wind L`}</strong>{`, optionally `}<strong parentName="p">{`Wind M`}</strong>{` if `}<strong parentName="p">{`Ice M`}</strong>{` used & `}<strong parentName="p">{`Thunder M`}</strong>{` skipped.`}</p>
    <p>{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`, go to `}<strong parentName="p">{`North Stonegard Pass`}</strong>{`.`}</p>
    <p>{`S&Q outside Murkwood, kill if you got the encounter before. Pick `}<strong parentName="p">{`$3500`}</strong>{`.`}<br parentName="p"></br>{`
`}{`In Murkwood kill encounter with L Stone`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul"><Cait mdxType="Cait">Cyrus: Blizzard, Merchant, Donate BP + Hired Help</Cait><NoCait mdxType="NoCait">Ophilia: Merchant, Donate BP + Hired Help</NoCait></li>
        <li parentName="ul">{`Tressa: Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul"><Cait mdxType="Cait">Cyrus</Cait><NoCait mdxType="NoCait">Ophilia</NoCait>: Endless Items</li>
        <li parentName="ul">{`Tressa: Endless Items`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "hrodvitnir-34969hp-sword-spear-ice-lightning-light"
    }}>{`Hrodvitnir 34969HP (Sword, Spear, Ice, Lightning, Light)`}</h4>
    <Cait mdxType="Cait">
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Lightning Blast`}</li>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Spear`}</strong></li>
        <li parentName="ul">{`Tressa: Defend`}</li>
        <li parentName="ul">{`Primrose: Summon`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: L Stone if no Inhibit Defenses / Nothing`}</li>
        <li parentName="ul">{`Cyrus: Nothing if no Inhibit Defenses / Defend`}</li>
        <li parentName="ul">{`Tressa: Attack x3`}</li>
        <li parentName="ul">{`Primrose: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-inhibit--no-inhibit"
      }}>{`Turn 3 (Inhibit / No Inhibit)`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Defend`}</li>
        <li parentName="ul">{`Ophilia: Lightning Blast x4 / L Stone`}</li>
        <li parentName="ul">{`Cyrus: HHV x4`}</li>
        <li parentName="ul">{`Tressa: Nothing / L Stone`}</li>
      </ul>
    </Cait>
    <NoCait mdxType="NoCait">
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Holy Light`}</li>
        <li parentName="ul">{`Cyrus: Defend`}</li>
        <li parentName="ul">{`Tressa: HHM x2`}</li>
        <li parentName="ul">{`Primrose: Summon`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: L Stone`}</li>
        <li parentName="ul">{`Cyrus: Lightning Blast`}</li>
        <li parentName="ul">{`Tressa: Nothing`}</li>
        <li parentName="ul">{`Primrose: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-inhibit--no-inhibit-1"
      }}>{`Turn 3 (Inhibit / No Inhibit)`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Defend`}</li>
        <li parentName="ul">{`Ophilia: HHV x4`}</li>
        <li parentName="ul">{`Cyrus: Lightning Blast x4 / L Stone`}</li>
        <li parentName="ul">{`Tressa: Nothing / L Stone`}</li>
      </ul>
    </NoCait>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`8 Empowering Bracelet`}</li>
        <li parentName="ul">{`2 Charm Robe, equip to Cyrus & Primrose`}</li>
      </ul>
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`All: 2x Empowering Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "healing"
      }}>{`Healing`}</h5>
      <p>{`Heal all.`}</p>
    </Menu>
    <h3 {...{
      "id": "chapter-3"
    }}>{`Chapter 3`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Pom M`}</strong>{`. Pick `}<strong parentName="p">{`$4500`}</strong>{`. Scrutinize `}<strong parentName="p">{`Wind L`}</strong>{`, pick `}<strong parentName="p">{`Pom M`}</strong>{`. Pick `}<strong parentName="p">{`Wind L`}</strong>{`.`}</p>
    <Cait mdxType="Cait">
      <p>{`After cutscene in church TP `}<strong parentName="p">{`Flamesgrace`}</strong>{`. Guide Flurry guy & TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    </Cait>
    <NoCait mdxType="NoCait">
      <p>{`TP `}<strong parentName="p">{`Grandport`}</strong>{` and TP back to `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    </NoCait>
    <p>{`Scrutinize & Pick `}<strong parentName="p">{`Thunder L`}</strong>{`. Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    <h3 {...{
      "id": "path-to-the-seaside-grotto"
    }}>{`Path to the Seaside Grotto`}</h3>
    <ul>
      <li parentName="ul">{`Azure Urchin: (1) 5611HP `}{`[Spear, Thunder, Light]`}</li>
      <li parentName="ul">{`Dark Curator: (3) 4790HP `}{`[Spear, Bow, Staff, Light]`}</li>
      <li parentName="ul">{`Flame Curator: (2) 4557HP `}{`[Spear, Bow, Staff, Ice]`}</li>
      <li parentName="ul">{`Scythe Crab: (3) 2484HP `}{`[Dagger, Axe, Wind]`}</li>
      <li parentName="ul">{`Mossy Tortoise: (4) 3808HP `}{`[Sword, Wind]`}</li>
    </ul>
    <h4 {...{
      "id": "battles"
    }}>{`Battles`}</h4>
    <ul>
      <li parentName="ul">{`1 Dark Curator 2 Flame Curator: go for Flurry, Blizzard.`}</li>
      <li parentName="ul">{`2 Dark Curator 1 Flame Curator: need a Flurry, can Blizzard to stall a bit. `}</li>
      <li parentName="ul">{`1 Azure Urchin 3 Scythe Crab: 3xHH800$ breaks crabs, Holy Light the Urchin. `}</li>
      <li parentName="ul">{`1 Azure Urchin 1 Mossy Tortoise: 4xHH150, Holy Light the Urchin`}</li>
      <li parentName="ul">{`1 Azure Urchin 1 Flame Curator 1 Scythe Crab: `}<ul parentName="li">
          <li parentName="ul">{`Ophilia Holy Light Azure Urchin, Cyrus Blizzard, Tressa Defend + 3HH800$`}</li>
          <li parentName="ul">{`If Prim before Tressa, can try to Dagger Scythe Crab to save a turn`}</li>
        </ul></li>
    </ul>
    <p>{`S&Q inside Seaside Grotto.`}</p>
    <h4 {...{
      "id": "mystery-man--shady-figure-2817232197hp"
    }}>{`Mystery Man & Shady Figure (28172/32197HP)`}</h4>
    <Cait mdxType="Cait">
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Pom M Tressa`}</li>
        <li parentName="ul">{`Cyrus: HHB`}</li>
        <li parentName="ul">{`Tressa: Defend`}</li>
        <li parentName="ul">{`Primrose: Summon`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: HHB x4`}</li>
        <li parentName="ul">{`Ophilia: Pom M Tressa`}</li>
        <li parentName="ul">{`Cyrus: Defend`}</li>
        <li parentName="ul">{`Primrose: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-inhibit--no-inhibit-2"
      }}>{`Turn 3 (Inhibit / No Inhibit)`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: L Stone if after break / Nothing`}</li>
        <li parentName="ul">{`Cyrus: HHM x4`}</li>
        <li parentName="ul">{`Ophilia: L Stone if Prim before break or no Inhibit / S Stone for range`}</li>
        <li parentName="ul">{`Tressa: HHV x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <p>{`Bit more damage / 1-2 L Stones (3 total in fight)`}</p>
      <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`, head to `}<strong parentName="p">{`Whispermill`}</strong>{`.`}</p>
    </Cait>
    <NoCait mdxType="NoCait">
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: HHB`}</li>
        <li parentName="ul">{`Cyrus: Pom M Tressa`}</li>
        <li parentName="ul">{`Tressa: Defend`}</li>
        <li parentName="ul">{`Primrose: Summon`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: HHB x4`}</li>
        <li parentName="ul">{`Ophilia: Defend`}</li>
        <li parentName="ul">{`Cyrus: Pom M Tressa`}</li>
        <li parentName="ul">{`Primrose: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-inhibit--no-inhibit-3"
      }}>{`Turn 3 (Inhibit / No Inhibit)`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: HHM x4`}</li>
        <li parentName="ul">{`Primrose: L Stone if after break / Nothing`}</li>
        <li parentName="ul">{`Cyrus: L Stone if Prim before break or no Inhibit / S Stone for range`}</li>
        <li parentName="ul">{`Tressa: HHV x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <p>{`Bit more damage / 1-2 L Stones (3 total in fight)`}</p>
      <p>{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`. Guide Flurry Woman, head to `}<strong parentName="p">{`Whispermill`}</strong>{`.`}</p>
    </NoCait>
    <p>{`If you need a backup stone pick `}<strong parentName="p">{`Light L`}</strong>{` in `}<strong parentName="p">{`Forest of Purgation`}</strong>{`.`}</p>
    <p>{`Break Plains Drake battle with Summons and flee.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$20000`}</strong>{`.`}</p>
    <h3 {...{
      "id": "chapter-4"
    }}>{`Chapter 4`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 Healing Grape M`}</li>
      </ul>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Everything till $89000`}</li>
      </ul>
    </Menu>
    <p>{`S&Q in second screen. Pick `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
    <h4 {...{
      "id": "cultists"
    }}>{`Cultists`}</h4>
    <p>{`Break with HHM x4, kill with 1 L Stone + 2 M Stone`}</p>
    <h4 {...{
      "id": "mattias-97686hp"
    }}>{`Mattias 97686HP`}</h4>
    <h5 {...{
      "id": "turn-1-4"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Cyrus: Blizzard`}</li>
      <li parentName="ul">{`Tressa: Pom L Self`}</li>
      <li parentName="ul">{`Primrose: Summon`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      